<template>
  <section>
    <v-container grid-list-md id="ctk_top">
      <div style="max-width:1515px; margin: 0 auto;">
      <v-layout wrap class="hidden-sm-and-down">
        <v-flex xs12 sm12 md12 lg12 mt-12 mb-12 class="news-h">集团动态</v-flex>
      </v-layout>
      <v-layout wrap mb-12 v-for="(item, n) in news.data" v-bind:key="'div-' + n" class="ctk-new-div">
          <!--PC-->
          <!--偶数-->
          <v-card flat class="hidden-sm-and-down" v-if="n % 2 ==0">
            <v-layout wrap>
              <v-flex xs12 sm12 md4 lg4>
                <a :href="'/new/' + item.id">
                  <v-img
                    :src="item.attach.path"
                    aspect-ratio="1.62"
                    height="300"
                  ></v-img>
                </a>
              </v-flex>
              <v-flex xs12 sm12 md8 lg8 pl-10 pr-10 class="text-left" style="position: relative; padding: 20px;" :key="n">
                <a :href="'/new/' + item.id">
                  <h3 class="ctk-news-title">{{item.title}}</h3>
                  <section class="ctk-news-profile">{{item.profile}}...</section>
                </a>
                <div class="ctk-news-date">
                  <span>{{item.create_time.substring(0, 10)}}</span>
                </div>
              </v-flex>
            </v-layout>
          </v-card>
          <!--奇数-->
          <v-card flat class="hidden-sm-and-down" v-else>
            <v-layout wrap>
              <v-flex xs12 sm12 md8 lg8 pl-10 pr-10 class="text-left" style="position: relative; padding: 20px;" :key="n">
                <a :href="'/new/' + item.id">
                  <h3 class="ctk-news-title">{{item.title}}</h3>
                  <section class="ctk-news-profile">{{item.profile}}...</section>
                </a>
                <div class="ctk-news-date">
                  <span>{{item.create_time.substring(0, 10)}}</span>
                </div>
              </v-flex>
              <v-flex xs12 sm12 md4 lg4>
                <a :href="'/new/' + item.id">
                  <v-img
                    :src="item.attach.path"
                    aspect-ratio="1.62"
                    height="300"
                  ></v-img>
                </a>
              </v-flex>
            </v-layout>
          </v-card>
          <!--手机-->
          <v-card flat class="hidden-md-and-up">
            <v-layout wrap>
              <v-flex xs12 sm12 md12 lg12 class="text-left" :key="n" style="padding: 20px;">
                <a :href="'/new/' + item.id">
                  <h3 class="ctk-news-title">{{item.title}}</h3>
                  <!-- <section class="ctk-news-profile">{{item.profile}}</section> -->
                  <div class="ctk-news-date-m">
                    <span>{{item.create_time.substring(0, 10)}}</span>
                  </div>
                </a>
              </v-flex>
              <v-flex xs12 sm12 md12 lg12>
                <a :href="'/new/' + item.id">
                  <img :src="item.attach.path" width="100%"/>
                </a>
              </v-flex>
            </v-layout>
          </v-card>
      </v-layout>
      <template v-if="totalPage > 1">
        <div class="text-center">
          <v-pagination
            v-model="page"
            :length="totalPage"
            circle
          ></v-pagination>
        </div>
      </template>
      </div>
    </v-container>
  </section>
</template>
<script>
export default {
  data: () => ({
    news: [],
    newsType: null,
    page: null,
    totalPage: 1
  }),
  created () {
    this.newsType = 2
    this.page = 1
  },
  watch: {
    params: {
      handler: function (val, oldVal) {
        let type = val.newsType
        let page = val.page
        document.querySelector('#ctk_top').scrollIntoView(true)
        this.getNews(type, page)
      },
      deep: true
    }
  },
  computed: {
    info () {
      return this.$store.getters.companyInfo
    },
    params () {
      const { newsType, page } = this
      return {
        newsType,
        page
      }
    }
  },
  methods: {
    getNews (type = 2, page = 1) {
      this.totalPage = 1
      this.https.get('news', { type: type, page: page }).then(response => {
        if (response.code === 0) {
          this.news = response.data
          this.totalPage = this.news.last_page
          this.page = page
        }
      })
    }
  }
}
</script>
<style lang="css">
  @import '../css/news.css';
  .v-main__wrap {
      background: #F6F6F6;
      padding-bottom: 100px;
  }
  .ctk-footer {
    background: #FFF !important;
  }
</style>
